var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mb-2 mt-2"},[_c('vue-picture-swipe',{attrs:{"items":_vm.images,"options":{ shareEl: false, rotationOn: true, history: false }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }